var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',{style:({ borderTop: _vm.color ? `7px solid ${_vm.color}` : '' })},[_c('p',{staticClass:"mb-0"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_c('v-simple-table',{staticClass:"stats-card-table",scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }